/// <amd-module name="VSS/Diagnostics/Dialog/PerfFeedbackDialog" />
import { PerfSettingsProps } from "VSS/Diagnostics/PerfBar";
import { IVssPageContext, IVssService, Services, VssService } from "VSS/Platform/Context";
import { IVssNavigationService } from "VSS/Platform/Navigation";
import {
    IContributionDiagnostics,
    IDiagnosticData,
    IEvaluatedCondition,
    IEvaluatedRelationship,
    IPageData,
    IVssPageService
} from "VSS/Platform/Page";
import { IPerfDialogMeasurement, IPerformanceStatistic, IVssPerformanceViewService, IPerformanceView } from "VSS/Diagnostics/PerformanceViewService";
import {
    Components,
    IVssComponentContext,
    IVssComponentProperties,
    VssComponent,
    IVssLayoutManager,
    WrappedComponent,
    IVssComponentDetail
} from "VSS/Platform/Layout";
import { IVssPerformanceService, IVssScenario } from "VSS/Platform/Performance";
import React = require("react");
import { Dialog } from "VSSUI/Dialog";

interface IPerfFeedbackDialogProps extends IVssComponentProperties {
    onDismiss: () => any;
}

interface IPerfFeedbackDialogState {}

class PerfFeedbackDialog extends VssComponent<IPerfFeedbackDialogProps, IPerfFeedbackDialogState> {
    public render(): JSX.Element {
        const performanceService = this.context.pageContext.getService<IVssPerformanceService>("IVssPerformanceService");
        const scenarios = performanceService.getCompletedScenarios();

        const pageDataService = this.context.pageContext.getService<IVssPageService>("IVssPageService");
        const navigationService = this.context.pageContext.getService<IVssNavigationService>("IVssNavigationService");

        const feedbackText = JSON.stringify(
            {
                routeId: navigationService.getCurrentRoute().routeId,
                userAgent: navigator ? navigator.userAgent : "",
                navigation: navigationService.getDisplayedNavigation(),
                pageData: pageDataService.getData(),
                scenarios: scenarios && scenarios.map(s => performanceService.getScenarioTelemetry(s))
            },
            null,
            2
        );

        return (
            <Dialog
                onDismiss={this.props.onDismiss}
                calloutContentClassName="bolt-dialog performance-dialog dialog-full-size dialog--feedback"
                lightDismiss={false}
                showCloseButton={true}
                titleProps={{ text: "Performance Feedback" }}
            >
                <div className="feedback-info">
                    <span>
                        Copy/Paste the following JSON and send an e-mail to:{" "}
                        <a href="mailto:VSOWebPerfFeedback@microsoft.com">VSOWebPerfFeedback@microsoft.com</a>.
                    </span>
                </div>
                <div className="feedback-info">
                    <span>Include the page that you are loading in the subject and any additional comments about your experience in the body.</span>
                </div>
                <textarea className="feedback-json flex-grow" value={feedbackText} />
            </Dialog>
        );
    }
}

Components.add("vss.perf-feedback-dialog", PerfFeedbackDialog);
